import { useMemo, useState } from 'react';
import type { ColumnDef, PaginationState, TableOptions } from '@tanstack/react-table';

type InstanceConfiguration<T> = Partial<Omit<TableOptions<T>, 'data'>> & {
  columns: ColumnDef<T, any>[];
};

export const useEventRelationshipsTableState = <T>(columns: Array<ColumnDef<T, any>>) => {
  const memoizedColumns = useMemo(() => columns, []);

  const [pagination, setLocalPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 5,
  });

  const defaultValue = useMemo(() => [], []);

  const instanceConfiguration: InstanceConfiguration<T> = {
    columns: memoizedColumns,
    autoResetPageIndex: false,
    state: {
      pagination,
    },
    onPaginationChange: (setPagination: any) => {
      setLocalPagination(setPagination(pagination));
    },
  };

  return {
    pageIndex: pagination.pageIndex,
    instanceConfiguration,
    defaultValue,
  };
};
